define('ims/comments',["exports", "core/pubsubhub"], function (exports, _pubsubhub) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.name = undefined;
  exports.run = run;
  const name = exports.name = "ims/comments";

  function run(conf, doc, cb) {
    //remove all document comment nodes

    var nodeIterator = doc.createNodeIterator(doc.documentElement, NodeFilter.SHOW_COMMENT);
    var comments = [];
    var currentNode;

    while (currentNode = nodeIterator.nextNode()) {
      comments.push(currentNode);
    }

    comments.forEach(function (comment) {
      comment.parentElement.removeChild(comment);
    });

    cb();
  }
});
//# sourceMappingURL=comments.js.map;
